import PropTypes from 'prop-types';
import { AddressVerificationStatusValues } from '../enums/address-verification-status';

export const AddressVerificationStatusPropType = PropTypes.oneOf(AddressVerificationStatusValues);

/**
 * @typedef {('VER'|'UNV'|'WRN'|'ERR')} AddressVerificationStatusType
 */
